import type { ReactNode } from 'react'
import Button from '@/components/ui/Button/Button'
import {TextMidd} from '@/components/ui/Text'
import ImgLogoOutline from '@/assets/icons/img-logo-outline.svg?react'
import css from './Empty.module.css'
import TextMiddBold from "@/components/ui/Text/TextMiddBold.tsx";

interface EmptyProps {
    title: string
    text: ReactNode
    button?: ReactNode
    buttonTitle?: string
    onClick?: () => void
    testId?: string
    /* Center within the nearest positioned parent (e.g. a Modal card) instead of
       the whole viewport. Use when Empty is modal content, not a full page. */
    contained?: boolean
}

const Empty = ({title, text, button, buttonTitle, onClick, testId, contained = false}: EmptyProps) => {
    const emptyClass = contained ? `${css.empty} ${css.contained}` : css.empty
    return (
        <div className={emptyClass} data-testid={testId}>
            <div className={css.logo}>
                <ImgLogoOutline/>
            </div>
            <TextMiddBold>{title}</TextMiddBold>
            <TextMidd className={css.text}>{text}</TextMidd>
            {button ? (
                <div className={css.button}>{button}</div>
            ) : buttonTitle && onClick ? (
                <div className={css.button}>
                    <Button title={buttonTitle} type="white" size="medium" onClick={onClick}/>
                </div>
            ) : null}
        </div>
    )
}

export default Empty
